import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FormField } from '../form';
import { BaseInput, Button } from '../ui';
import { useMutation } from '@/hooks';
import { saveJobFilter } from '@/api';
import { useJobsContext } from '@/hoc';
export var SaveFilterForm = function (_a) {
    var setShowSaveSection = _a.setShowSaveSection, refetchSaveJobFilters = _a.refetchSaveJobFilters, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.buttonWidth, buttonWidth = _c === void 0 ? 'w-full' : _c;
    var _d = useState(''), filterName = _d[0], setFilterName = _d[1];
    var filters = useJobsContext().filters;
    var _e = useMutation({
        mutationFn: function (filterPayload) { return saveJobFilter(filterPayload); },
        onSuccess: function () {
            setShowSaveSection === null || setShowSaveSection === void 0 ? void 0 : setShowSaveSection(false);
            setFilterName('');
            refetchSaveJobFilters();
        },
    }), saveFilter = _e.mutate, isSaveFilterMutationLoading = _e.isLoading;
    var handleSaveFilter = function () {
        if (!filterName.trim()) {
            return;
        }
        // Group applied filters by queryKey
        var groupedFilters = filters.appliedFilters.reduce(function (acc, filter) {
            if (!acc[filter.queryKey]) {
                acc[filter.queryKey] = [];
            }
            acc[filter.queryKey].push(filter.value);
            return acc;
        }, {});
        // Transform grouped filters into the required payload format
        var selectedFilters = Object.entries(groupedFilters).map(function (_a) {
            var filterType = _a[0], values = _a[1];
            return ({
                filterType: filterType,
                value: values.length === 1 ? values[0] : values,
            });
        });
        var payload = {
            saved_filter_name: filterName,
            selected_filters: selectedFilters,
        };
        saveFilter(payload);
    };
    return (_jsxs("div", { className: "flex flex-col w-full gap-2 ".concat(className), children: [_jsx(FormField, { label: 'Filter Name', htmlFor: 'filter-name', children: _jsx(BaseInput, { id: 'filter-name', placeholder: 'Enter Filter Name', className: '!outline-none bg-gray-200 !w-full !max-h-8 !rounded-md !p-2', value: filterName, onChange: function (e) { return setFilterName(e.target.value); } }) }), _jsxs("div", { className: 'flex gap-2', children: [_jsx(Button, { variant: 'secondary', size: 'sm', className: "px-4 ".concat(buttonWidth), onClick: function () {
                            setShowSaveSection === null || setShowSaveSection === void 0 ? void 0 : setShowSaveSection(false);
                            setFilterName('');
                        }, children: "Cancel" }), _jsx(Button, { variant: 'primary', size: 'sm', className: "px-4 ".concat(buttonWidth), onClick: handleSaveFilter, disabled: !filterName.trim(), isLoading: isSaveFilterMutationLoading, children: "Save" })] })] }));
};
